import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import { Pagination, Autoplay, Navigation } from "swiper/modules";
import Navbar from "./_shared/NavBar";
import FirstDescImage from "../assets/lpfp.jpeg";
import SecondDescImage from "../assets/backgrounds/clan.jpg";
import Nutons from "../assets/cartes/nutons.jpg";
import Lutins from "../assets/secondPic/lutins.jpg";
import Louveteaux from "../assets/cqntac.jpg";
import Guides from "../assets/cartes/guides.jpg";
import Scouts from "../assets/cartes/scouts.jpg";
import Clan from "../assets/cartes/clan.jpg";
import FooterSection from "./_shared/FooterSection";
import SectionRepository from "../infrastructure/SectionRepository";

const LandingPage = () => {
    const [backgrounds, setBackgrounds] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        // Fonction optimisée pour traiter les buffers d'image
        function processBuffer(buffer) {
            if (!buffer || !buffer.data || !Array.isArray(buffer.data)) {
                return null;
            }

            // Utilisation d'un traitement par blocs pour éviter les erreurs de mémoire
            const data = buffer.data;
            let result = '';
            const chunkSize = 8192;  // Traiter des blocs de 8K à la fois

            for (let i = 0; i < data.length; i += chunkSize) {
                const chunk = data.slice(i, i + chunkSize);
                result += String.fromCharCode.apply(null, chunk);
            }

            return result;
        }

        const fetchData = async () => {
            try {
                const sectionRepository = new SectionRepository();
                const sectionsBackgrounds = await sectionRepository.getAllBackgroundImage();

                const processed = sectionsBackgrounds
                    .map(item => {
                        if (item.background && item.background.type === "Buffer") {
                            return { background: processBuffer(item.background) };
                        }
                        return item;
                    })
                    .filter(item => item.background); // Filtrer les résultats sans image

                setBackgrounds(processed);
            } catch (error) {
                console.error("Error fetching backgrounds:", error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();
    }, []);

    return (
        <div className="bg-gray-100 overflow-x-hidden">
            {/* Hero Section */}
            <div className="relative bg-cover bg-center h-[40rem]">
                <Navbar />
                <div className="absolute inset-0 flex items-center justify-center z-10 px-4">
                    <h1 className="text-white text-6xl sm:text-6xl md:text-8xl font-bold italic text-center text-wrap" style={{fontFamily: "Anton, sans-serif"}}>
                        Unité Sainte-Véronique
                    </h1>
                </div>

                {/* Swiper avec état de chargement */}
                {isLoading ? (
                    <div className="h-[40rem] bg-gray-700 flex items-center justify-center">
                        <div className="text-white text-xl">Chargement...</div>
                    </div>
                ) : backgrounds.length > 0 ? (
                    <Swiper
                        loop={true}
                        autoplay={{
                            delay: 3000,
                            disableOnInteraction: false,
                        }}
                        pagination={{
                            el: ".swiper-pagination",
                            type: "progressbar",
                        }}
                        modules={[Pagination, Autoplay, Navigation]}
                        className="swiper-container h-[40rem]"
                    >
                        {backgrounds.map((background, index) => (
                            <SwiperSlide key={index}>
                                <div
                                    className="w-full h-[40rem] bg-cover bg-center"

                                style={{backgroundImage: `url(${require(`../assets${background.background}`)})` }}
                                />
                            </SwiperSlide>
                        ))}
                    </Swiper>
                ) : (
                    <div className="h-[40rem] bg-gray-700 flex items-center justify-center">
                        <div className="text-white text-xl">Aucune image disponible</div>
                    </div>
                )}
            </div>

            {/* À propos de nous Section */}
            <div className="container mx-auto my-12 px-4 pb-16">
                <h2 className="text-4xl font-anton text-green-600 mb-6 italic">
                    À Propos de Nous
                </h2>
                <div className="flex flex-col lg:flex-row mx-0">
                    <div className="w-full lg:w-1/3 px-4 mb-8 lg:mb-0">
                        <p className="text-gray-700 leading-relaxed mb-4">
                            Depuis plus d'un demi-siècle, l'unité Sainte Véronique à Liège
                            offre à des jeunes de 6 à 18 ans la possibilité de goûter aux
                            joies des mouvements de jeunesse. Une source d'amusement autant
                            que d'apprentissage pour tous, des plus petits aux plus grands. On
                            y apprend à vivre en groupe, à mieux connaître sa ville et son
                            pays, à découvrir la nature qui nous entoure, à éveiller sa
                            curiosité et sa citoyenneté.
                        </p>
                        <p className="text-gray-700 leading-relaxed">
                            Encadrés par des jeunes de qualité, les enfants se voient offrir
                            des activités variées, tantôt dans Liège, tantôt à la campagne,
                            tantôt pour une matinée, tantôt pour tout un week-end. Il y en a
                            pour tous les goûts !
                        </p>
                    </div>
                    <div className="w-full lg:w-2/3 px-4 flex flex-col sm:flex-row gap-4 sm:gap-8 justify-center lg:justify-start">
                        <div className="w-full sm:w-1/2 flex justify-center lg:justify-start mb-4 sm:mb-0">
                            <img
                                className="rounded-lg shadow-lg w-4/5 sm:w-full lg:max-w-sm transform lg:-translate-y-10"
                                src={FirstDescImage}
                                alt="d'activités"
                                loading="lazy"
                                width="400"
                                height="300"
                            />
                        </div>
                        <div className="w-full sm:w-1/2 flex justify-center lg:justify-start">
                            <img
                                className="rounded-lg shadow-lg w-4/5 sm:w-full lg:max-w-sm transform lg:translate-y-16"
                                src={SecondDescImage}
                                alt="groupe"
                                loading="lazy"
                                width="400"
                                height="300"    
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* Nos Sections */}
            <Sections />

            {/* Last Section - intégré directement */}
            <LastSection />

            {/* Footer */}
            <FooterSection/>
        </div>
    );
};

// Définir sectionsData à l'extérieur pour éviter sa recréation à chaque rendu
const sectionsData = [
    { title: "Les Nutons", image: Nutons, id: 5 },
    { title: "Les Louveteaux", image: Louveteaux, id: 4 },
    { title: "Les Lutins", image: Lutins, id: 3 },
    { title: "Les Guides", image: Guides, id: 2 },
    { title: "Les Scouts", image: Scouts, id: 1 },
    { title: "Staff d'unité et clan", image: Clan, id: 6 },
];

// Sections component optimisé
const Sections = () => {
    const [desc, setDesc] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        // Fonction optimisée pour traiter les buffers d'image
        function processBuffer(buffer) {
            if (!buffer || !buffer.data || !Array.isArray(buffer.data)) {
                return null;
            }

            // Utilisation d'un traitement par blocs pour éviter les erreurs de mémoire
            const data = buffer.data;
            let result = '';
            const chunkSize = 8192;  // Traiter des blocs de 8K à la fois

            for (let i = 0; i < data.length; i += chunkSize) {
                const chunk = data.slice(i, i + chunkSize);
                result += String.fromCharCode.apply(null, chunk);
            }

            return result;
        }

        const fetchData = async () => {
            try {
                const sectionRepository = new SectionRepository();
                const sectionsDescImages = await sectionRepository.getAllDescImage();

                const processed = sectionsDescImages.map(item => {
                    if (item.first_picture && item.first_picture.type === "Buffer") {
                        return { ...item, first_picture: processBuffer(item.first_picture) };
                    }
                    return item;
                });

                setDesc(processed);
            } catch (error) {
                console.error("Error fetching section data:", error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();
    }, []);

    return (
        <div className="bg-zinc-800 py-12">
            <div className="container mx-auto px-4">
                <h2 className="font-anton text-4xl sm:text-5xl text-white text-center mb-8 italic">
                    Nos Sections
                </h2>
                {isLoading ? (
                    <div className="text-white text-center py-12">Chargement des sections...</div>
                ) : (
                    <div className="flex justify-center">
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 sm:gap-12 lg:gap-16 xl:gap-24">
                            {sectionsData.map((section, index) => {
                                const sectionImage = desc[section.id - 1]?.first_picture || section.image;
                                return (
                                    <SectionCard
                                        key={index}
                                        title={section.title}
                                        image={sectionImage}
                                        id={section.id}
                                    />
                                );
                            })}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

// SectionCard component optimisé
const SectionCard = ({ title, image, id }) => {
    return (
        <a href={`/Staff/${id}`}>
            <div className="relative bg-gray-900 rounded-lg shadow-lg overflow-hidden mx-auto h-72 sm:h-80 lg:h-96 w-full max-w-xs card-zoom">
                <img
                    className="w-full h-full object-cover card-zoom-image"
                    src={require(`../assets${image}`)}

                    alt={title}
                    loading="lazy"
                    width="300"
                    height="400"
                />
                <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50">
                    <h3
                        className="text-white text-3xl card-zoom-text"
                        style={{fontFamily: "Anton, sans-serif"}}
                    >
                        {title}
                    </h3>
                </div>
            </div>
        </a>
    );
};

// Composant LastSection
const LastSection = () => {
    return (
        <div
            className="relative bg-cover bg-center h-[50rem]"
            style={{ backgroundImage: `url(${Louveteaux})` }}
        >
            <div className="absolute inset-0 bg-black bg-opacity-50 flex flex-col items-center justify-center text-center px-4 py-12">
                <h2 className="text-3xl sm:text-4xl md:text-5xl font-anton text-green-600 mb-6 md:mb-7 italic">
                    CE QUI NOUS TIENS À COEUR
                </h2>
                <p className="text-white text-base md:text-lg font-semibold leading-relaxed max-w-4xl mb-12 md:mb-20">
                    Dans chaque section, des plus jeunes aux plus âgés, ce qui nous tient
                    à cœur, c'est que chacun puisse découvrir en s'amusant. Que nulle ne
                    soit exclu, que les jeunes apprennent à découvrir, à se découvrir et
                    à découvrir les autres. <br />
                    <br />
                    Nous voulons également montrer aux jeunes qu'il est possible de
                    s'amuser autrement que devant les écrans, qu'il y a un nombre de
                    choses incroyables à voir et à faire autour de chez soi. <br />
                    <br />
                    Les mouvements de jeunesse sont à nos yeux autant un endroit
                    d'apprentissage qu'un endroit d'amusement.
                </p>
            </div>
        </div>
    );
};

export default LandingPage;